import type { User } from "@/shared/generated/graphql";
import { AppIdentifier } from "@/shared/@types/AppIdentifier";
import type { CustomerBase } from "@/shared/@types/CustomerBase";

// Returns an array of customer IDs for which the user has permission based on the specified app
export const getCustomerIdsWithAppPermission = (
  permissions: User["permissions"],
  allCustomers: Array<CustomerBase>,
  app?: AppIdentifier,
): Array<string> => {
  switch (app) {
    case AppIdentifier.Equivolt:
      return [
        permissions.fleetAtHomeUserCustomerId,
        ...(permissions.fleetAtHomeManagerCustomerIds ?? []),
      ].filter((id): id is string => !!id);
    case AppIdentifier.WccManagement:
      return permissions.wccManagerCustomerIds ?? [];
    case AppIdentifier.WscManagement:
      return permissions.wscManagerCustomerIds ?? [];
    case AppIdentifier.ThgQuote:
      return permissions.thgQuoteManagerCustomerIds ?? [];
    case AppIdentifier.WestfalenIdAccountManagement:
      return permissions.westfalenIdAccountManagerCustomerIds ?? [];
    case AppIdentifier.FbsHub:
      return permissions.fbsUserCustomerIds ?? [];
    case AppIdentifier.GasShop:
      return [
        ...(permissions.gasStoremanCustomerIds ?? []),
        ...(permissions.gasOciCustomerIds ?? []),
        ...(permissions.gasRequesterCustomerIds ?? []),
        ...(permissions.globalGasStoremanCustomerIds ?? []),
      ].filter((id): id is string => !!id);
    default:
      // If the app is not recognized, return all customer IDs
      return allCustomers.map((customer) => customer.id);
  }
};
